import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import './lock-component.scss';
import GuestComponent from '../guest-popup/GuestComponent';

class Lock extends PureComponent {
  render() {
    return (
      <div className="lock-component-wrapper">
        <div className="guest-lock-component">
          <GuestComponent />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.userInfo,
  locale: state.i18n.locale,
});

export default connect(mapStateToProps)(Lock);
